import { render, staticRenderFns } from "./SizeChart.vue?vue&type=template&id=67d7cb34&scoped=true&"
import script from "./SizeChart.vue?vue&type=script&lang=js&"
export * from "./SizeChart.vue?vue&type=script&lang=js&"
import style0 from "./SizeChart.vue?vue&type=style&index=0&id=67d7cb34&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d7cb34",
  null
  
)

export default component.exports